import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-badge-dropdown',
  templateUrl: './badge-dropdown.component.html',
  styleUrls: ['./badge-dropdown.component.scss']
})
export class BadgeDropdownComponent {
  @Input() selected: any;
  @Input() badges: any[] = [];
  @Output() badgeSelected = new EventEmitter<any>();

  dropdownOpen = false;
  hovered: any = null;

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  select(insignia: any) {
    this.badgeSelected.emit(insignia);
    this.dropdownOpen = false;
  }

  ngOnInit() {
    console.log('Badges recibidos:', this.badges);
    //console.log('Selected:', this.selected);
  }

}